import React from "react";

const ButtonLoader = () => {
  return (
    <button className="buttonload group relative prm-btn h-fit">
      <span className="absolute left-[20px] flex items-center ">
        <i className="fa fa-spinner fa-spin text-white text-[14px]"></i>
      </span>
      <span className="ml-[20px]">
      Loading
      </span>
    </button>
  );
};

export default ButtonLoader;
